// import React, { useState, useEffect } from "react";
// import "./Header.css";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebookF,
//   faLinkedinIn,
//   faInstagram,
// } from "@fortawesome/free-brands-svg-icons";
// import {
//   faBars,
//   faPhone,
//   faXmark,
//   fas,
// } from "@fortawesome/free-solid-svg-icons";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import GoogleTranslate from "../../New_Folder/Header/GoogleTranslate/GoogleTranslate";

// library.add(fas);

// const Header = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [activeLink, setActiveLink] = useState("home");
//   const [showOffcanvas, setShowOffcanvas] = useState(false);

//   useEffect(() => {
//     const path = location.pathname.substring(1);

//     if (
//       path === "export-services" ||
//       path === "services-category" ||
//       path === "product-details"
//     ) {
//       setActiveLink("services");
//     } else {
//       setActiveLink(path || "home");
//     }
//   }, [location.pathname]);

//   const handleNavItemClick = (selectedLink) => {
//     setActiveLink(selectedLink);
//     setShowOffcanvas(false);
//   };

//   const handleLogoClick = () => {
//     navigate("/");
//     setShowOffcanvas(false);
//   };

//   const navLinks = [
//     {
//       title: "Home",
//       path: "/home",
//       key: "home",
//     },
//     {
//       title: "About Us",
//       path: "/about-us",
//       key: "about-us",
//     },
//     {
//       title: "Services",
//       path: "/services",
//       key: "services",
//     },
//     {
//       title: "Quality Assurance",
//       path: "/quality-assurance",
//       key: "quality-assurance",
//     },
//     {
//       title: "Contact Us",
//       path: "/contact-us",
//       key: "contact-us",
//     },
//     {
//       title: "Gallery",
//       path: "/gallery",
//       key: "gallery",
//     },
//     {
//       title: "Blog",
//       path: "/blog",
//       key: "blog",
//     },
//   ];

//   return (
//     <>
//       <section className="main-header">
//         {/* TOP HEADER */}
//         <div className="top-header">
//           <Container>
//             <div className="top_div">
//               {/* PHONE */}
//               <div className="d-flex social-icon number_div">
//                 <div className="border-icon text-center">
//                   <FontAwesomeIcon icon={faPhone} className="fb-icon" />
//                 </div>

//                 <span>+91 9762331812</span>
//               </div>

//               {/* LOGO */}
//               <div
//                 className="image-holder my-2 text-center"
//                 onClick={handleLogoClick}
//               >
//                 <img
//                   className="headlogo"
//                   src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
//                   alt="Logo"
//                 />
//               </div>

//               {/* DESKTOP SOCIAL LINKS */}
//               <div className="d-flex justify-content-center social-icon desktop-social">
//                 <div className="translator">
//                   <GoogleTranslate />
//                 </div>

//                 {/* MOBILE TOGGLE */}
//                 {/* <Navbar.Toggle
//                   aria-controls="mobile-offcanvas"
//                   onClick={() => setShowOffcanvas(true)}
//                 /> */}

//                 <button
//                   type="button"
//                   className="mobile-menu-btn"
//                   onClick={() => setShowOffcanvas(true)}
//                   aria-label="Open menu"
//                 >
//                   <FontAwesomeIcon icon={faBars} />
//                 </button>

//                 <div className="social_links d-none d-lg-flex align-items-center">
//                   <a
//                     href="https://www.facebook.com/"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <div className="border-icon text-center">
//                       <FontAwesomeIcon icon={faFacebookF} className="fb-icon" />
//                     </div>
//                   </a>

//                   <a
//                     href="https://in.linkedin.com/"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <div className="border-icon text-center">
//                       <FontAwesomeIcon
//                         icon={faLinkedinIn}
//                         className="fb-icon"
//                       />
//                     </div>
//                   </a>

//                   <a
//                     href="https://www.instagram.com/"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <div className="border-icon text-center">
//                       <FontAwesomeIcon icon={faInstagram} className="fb-icon" />
//                     </div>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </Container>
//         </div>

//         {/* DESKTOP NAVIGATION */}
//         <div className="second-header">
//           <Container>
//             <Navbar expand="lg">
//               {/* DESKTOP NAV */}
//               <Navbar.Collapse id="basic-navbar-nav">
//                 <Nav className="mx-auto">
//                   {navLinks.map((item) => (
//                     <Nav.Link
//                       key={item.key}
//                       as={Link}
//                       to={item.path}
//                       className={`nav-link-with-borders ${
//                         activeLink === item.key ? "active" : ""
//                       }`}
//                       onClick={() => handleNavItemClick(item.key)}
//                     >
//                       {item.title}

//                       <div>
//                         <div className="white-border"></div>
//                       </div>
//                     </Nav.Link>
//                   ))}
//                 </Nav>
//               </Navbar.Collapse>
//             </Navbar>
//           </Container>
//         </div>

//         {/* MOBILE OFFCANVAS */}
//         <Offcanvas
//           show={showOffcanvas}
//           onHide={() => setShowOffcanvas(false)}
//           placement="end"
//           className="mobile_offcanvas"
//         >
//           <Offcanvas.Header>
//             <Offcanvas.Title>
//               <img
//                 className="mobile_offcanvas_logo"
//                 src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
//                 alt="Logo"
//                 onClick={handleLogoClick}
//               />
//             </Offcanvas.Title>

//             <button
//               type="button"
//               className="offcanvas_close_btn"
//               onClick={() => setShowOffcanvas(false)}
//             >
//               <FontAwesomeIcon icon={faXmark} />
//             </button>
//           </Offcanvas.Header>

//           <Offcanvas.Body>
//             {/* MOBILE NAV LINKS */}
//             <div className="mobile_nav_links">
//               {navLinks.map((item) => (
//                 <Link
//                   key={item.key}
//                   to={item.path}
//                   className={`mobile_nav_link ${
//                     activeLink === item.key ? "active" : ""
//                   }`}
//                   onClick={() => handleNavItemClick(item.key)}
//                 >
//                   <span>{item.title}</span>

//                   <div className="mobile_nav_line"></div>
//                 </Link>
//               ))}
//             </div>

//             {/* MOBILE SOCIAL SECTION */}
//             <div className="mobile_social_section">
//               <h6>Follow Us</h6>

//               <div className="mobile_social_links">
//                 <a
//                   href="https://www.facebook.com/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <div className="border-icon text-center">
//                     <FontAwesomeIcon icon={faFacebookF} className="fb-icon" />
//                   </div>
//                 </a>

//                 <a
//                   href="https://in.linkedin.com/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <div className="border-icon text-center">
//                     <FontAwesomeIcon icon={faLinkedinIn} className="fb-icon" />
//                   </div>
//                 </a>

//                 <a
//                   href="https://www.instagram.com/"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <div className="border-icon text-center">
//                     <FontAwesomeIcon icon={faInstagram} className="fb-icon" />
//                   </div>
//                 </a>
//               </div>

//               <div className="mobile_translator">
//                 <GoogleTranslate />
//               </div>
//             </div>

//             {/* MOBILE PHONE */}
//             <div className="mobile_phone">
//               <div className="border-icon text-center">
//                 <FontAwesomeIcon icon={faPhone} className="fb-icon" />
//               </div>

//               <span>+91 9762331812</span>
//             </div>
//           </Offcanvas.Body>
//         </Offcanvas>
//       </section>
//     </>
//   );
// };

// export default Header;
import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faBars,
  faPhone,
  faXmark,
  fas,
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(fas);

/* =====================================================
   GOOGLE TRANSLATE
   The widget is created ONCE in public/index.html
   (#google_translate_element inside #gt-holder).
   Each header just moves that same element into its slot,
   so nothing is re-initialized and no reload is needed.
===================================================== */
const moveTranslatorTo = (slot) => {
  const widget = document.getElementById("google_translate_element");
  if (widget && slot) slot.appendChild(widget);
};

const parkTranslator = () => {
  const widget = document.getElementById("google_translate_element");
  const holder = document.getElementById("gt-holder");
  if (widget && holder) holder.appendChild(widget);
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeLink, setActiveLink] = useState("home");
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const desktopTranslatorSlot = useRef(null);
  const mobileTranslatorSlot = useRef(null);

  // Put the widget in the top bar when this header mounts,
  // and park it back in the hidden holder when it unmounts.
  useLayoutEffect(() => {
    moveTranslatorTo(desktopTranslatorSlot.current);
    return () => parkTranslator();
  }, []);

  useEffect(() => {
    const path = location.pathname.substring(1);

    if (
      path === "export-services" ||
      path === "services-category" ||
      path === "product-details"
    ) {
      setActiveLink("services");
    } else {
      setActiveLink(path || "home");
    }
  }, [location.pathname]);

  const handleNavItemClick = (selectedLink) => {
    setActiveLink(selectedLink);
    setShowOffcanvas(false);
  };

  const handleLogoClick = () => {
    navigate("/");
    setShowOffcanvas(false);
  };

  const navLinks = [
    { title: "Home", path: "/home", key: "home" },
    { title: "About Us", path: "/about-us", key: "about-us" },
    { title: "Services", path: "/services", key: "services" },
    {
      title: "Quality Assurance",
      path: "/quality-assurance",
      key: "quality-assurance",
    },
    { title: "Contact Us", path: "/contact-us", key: "contact-us" },
    { title: "Gallery", path: "/gallery", key: "gallery" },
    { title: "Blog", path: "/blog", key: "blog" },
  ];

  return (
    <>
      <section className="main-header">
        {/* TOP HEADER */}
        <div className="top-header">
          <Container>
            <div className="top_div">
              {/* PHONE */}
              <div className="d-flex social-icon number_div">
                <div className="border-icon text-center">
                  <FontAwesomeIcon icon={faPhone} className="fb-icon" />
                </div>

                <span>+91 9762331812</span>
              </div>

              {/* LOGO */}
              <div
                className="image-holder my-2 text-center"
                onClick={handleLogoClick}
              >
                <img
                  className="headlogo"
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                  alt="Logo"
                />
              </div>

              {/* DESKTOP SOCIAL LINKS */}
              <div className="d-flex justify-content-center social-icon desktop-social">
                {/* TRANSLATOR SLOT (desktop) */}
                <div className="translator" ref={desktopTranslatorSlot}></div>

                <button
                  type="button"
                  className="mobile-menu-btn"
                  onClick={() => setShowOffcanvas(true)}
                  aria-label="Open menu"
                >
                  <FontAwesomeIcon icon={faBars} />
                </button>

                <div className="social_links d-none d-lg-flex align-items-center">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="border-icon text-center">
                      <FontAwesomeIcon icon={faFacebookF} className="fb-icon" />
                    </div>
                  </a>

                  <a
                    href="https://in.linkedin.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="border-icon text-center">
                      <FontAwesomeIcon
                        icon={faLinkedinIn}
                        className="fb-icon"
                      />
                    </div>
                  </a>

                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="border-icon text-center">
                      <FontAwesomeIcon icon={faInstagram} className="fb-icon" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </Container>
        </div>

    
        <div className="second-header">
          <Container>
            <Navbar expand="lg">
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mx-auto">
                  {navLinks.map((item) => (
                    <Nav.Link
                      key={item.key}
                      as={Link}
                      to={item.path}
                      className={`nav-link-with-borders ${
                        activeLink === item.key ? "active" : ""
                      }`}
                      onClick={() => handleNavItemClick(item.key)}
                    >
                      {item.title}

                      <div>
                        <div className="white-border"></div>
                      </div>
                    </Nav.Link>
                  ))}
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Container>
        </div>

        <Offcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          onEntered={() => moveTranslatorTo(mobileTranslatorSlot.current)}
    
          onExit={() => moveTranslatorTo(desktopTranslatorSlot.current)}
          placement="end"
          className="mobile_offcanvas"
        >
          <Offcanvas.Header>
            <Offcanvas.Title>
              <img
                className="mobile_offcanvas_logo"
                src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                alt="Logo"
                onClick={handleLogoClick}
              />
            </Offcanvas.Title>

            <button
              type="button"
              className="offcanvas_close_btn"
              onClick={() => setShowOffcanvas(false)}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </Offcanvas.Header>

          <Offcanvas.Body>
            {/* MOBILE NAV LINKS */}
            <div className="mobile_nav_links">
              {navLinks.map((item) => (
                <Link
                  key={item.key}
                  to={item.path}
                  className={`mobile_nav_link ${
                    activeLink === item.key ? "active" : ""
                  }`}
                  onClick={() => handleNavItemClick(item.key)}
                >
                  <span>{item.title}</span>

                  <div className="mobile_nav_line"></div>
                </Link>
              ))}
            </div>

            {/* MOBILE SOCIAL SECTION */}
            <div className="mobile_social_section">
              <h6>Follow Us</h6>

              <div className="mobile_social_links">
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="border-icon text-center">
                    <FontAwesomeIcon icon={faFacebookF} className="fb-icon" />
                  </div>
                </a>

                <a
                  href="https://in.linkedin.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="border-icon text-center">
                    <FontAwesomeIcon icon={faLinkedinIn} className="fb-icon" />
                  </div>
                </a>

                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="border-icon text-center">
                    <FontAwesomeIcon icon={faInstagram} className="fb-icon" />
                  </div>
                </a>
              </div>
              <div
                className="mobile_translator"
               
              ></div>
            </div>

            <div className="mobile_phone">
              <div className="border-icon text-center">
                <FontAwesomeIcon icon={faPhone} className="fb-icon" />
              </div>

              <span>+91 9762331812</span>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </section>
    </>
  );
};

export default Header;
